import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import { Paths } from '../../../shared/paths';

export function useTrainingsPage() {
  const { navigate } = useNavigationStack();
  const { t, i18n } = useTranslation();
  const [planDialogOpened, setPlanDialogOpen] = useState(false);

  const tabsConfig = useMemo(
    () => [
      {
        label: t('trainings.myTrainings'),
        path: Paths.trainings.toMy,
        onboardingKey: 'trainingPage.tab.my',
      },
      {
        label: t('trainings.fromMeTab'),
        path: Paths.trainings.toFromMe,
        onboardingKey: 'trainingPage.tab.fromMe',
      },
      {
        label: t('trainings.availableTab'),
        path: Paths.trainings.toAvailable,
        onboardingKey: 'trainingPage.tab.available',
      },
    ],
    [t, i18n.language],
  );

  function onStartEmptyTrainingClick() {
    navigate(Paths.trainings.toStartNew);
  }

  return {
    planDialogOpened,
    setPlanDialogOpen,
    tabsConfig,
    onStartEmptyTrainingClick,
  };
}
